// extracted by mini-css-extract-plugin
export default {"redGradient":"linear-gradient(-60deg, #ff6332, #ff4156)","tooltipPositionHint":"tooltipPositionHint__1Ka5D","extrasContainer":"extrasContainer__21IlF","tooltip":"tooltip__3eSUI","tooltipContent":"tooltipContent__2fehO","tooltipImage":"tooltipImage__2b7PM","tooltipSummary":"tooltipSummary__3pbyC"};
    if(module.hot) {
      // 1745482216293
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  